import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';

function PageSweepstakes() {
  const { content } = useAppStore();
  return (
    <Page className="pr-[17.875rem] pb-[27.3125rem]">
      
      <div className="flex flex-row h-full pl-[9.75rem] pt-[calc(32.6875rem-var(--header-height))]">
        <div className='flex flex-col font-extralight w-[38%] pt-[10rem]'>
            <div className='text-[5.625rem] leading-[8rem] mb-[3.8rem]'>{content.sweepstakes.title}</div>
            <div className='text-[#D9D9D9] text-[3.875rem] leading-[5.7rem]' dangerouslySetInnerHTML={{__html:content.sweepstakes.description}}></div>
        </div>
        <div className='flex-1 h-full relative flex items-center justify-center'>
          <div className='bg-gradient-animated-rotating w-[60%] aspect-square rounded-full blur-[100px]'></div>
          <img className='w-full h-full object-contain absolute top-0 left-0 rotate-[8deg] origin-center'
              src={`${process.env.PUBLIC_URL}/rayban.png`}
          />
        </div>
      </div>

      <div className='flex absolute right-[8rem] bottom-[6rem] items-center'>
        <div className='font-light text-[2.625rem] pr-[3.875rem]'>Terms and conditions</div>
        <img className='w-[9.6875rem] h-auto'
            src={`${process.env.PUBLIC_URL}/qr_raffle.png`}
        />
      </div>
    </Page>
  );
}

export default PageSweepstakes;